import React from 'react';
import request from '../../utils/agent';
import { Redirect } from "react-router-dom";
import { Formik, Field, FieldArray, Form } from 'formik';
import Recaptcha from 'react-recaptcha';
import * as Yup from 'yup';



export default class DistributrorForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            role: 'distributor',
            isError: false,
            isSubmited: false,
            cert_loc: null,
            uploadingCertificate: false,
            geo: null,
            lat: null,
            long: null,
            address_status: "",
            address: "",
            city: "",
            postal: "",
            country: "",
            state: "",
            touched: {
                address: false,
                city: false,
                postal: false,
                country: false,
                state: false,
            }
        };
    }

    componentDidMount() {
        const script = document.createElement("script");
        script.src =
            "https://www.google.com/recaptcha/api.js";
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);

        this.addressListener();
    }

    addressListener = (setFieldValue) => {
        const autocompleteFormField = document.getElementById(`addressAutocomplete.street`);

        const autocomplete = new google.maps.places.Autocomplete((autocompleteFormField), {
            types: [`address`]
        });

        google.maps.event.addListener(autocomplete, `place_changed`, () => {
            const place = autocomplete.getPlace();
            let ac = place.address_components;
            var address = {
                country: ac.filter(c => ~c.types.indexOf('country'))[0].short_name,
                street: place.name,
                city: ac.filter(c => ~c.types.indexOf('locality'))[0].long_name,
                state: ac.filter(c => ~c.types.indexOf('administrative_area_level_1'))[0].short_name,
                postal: ac.filter(c => ~c.types.indexOf('postal_code'))[0].short_name
            };

           // console.log(address); // This is our address selected component

            // I don't know how you would pass these to Formik.
            for(let key in address) {
                try {
                    document.getElementById(`addressAutocomplete.${key}`).value = address[key];
                    this.setState({
                        address: address.street,
                        city: address.city,
                        postal: address.postal,
                        country: address.country,
                        state: address.state,
                    })
                } catch(e) {
                    console.log(`Unable to set addressAutocomplete.${key}:${address[key]}`);
                }
            }

        });
    };

    handleAdrChange = (e) => {
        e.preventDefault();
        this.setState({
            address: e.target.value,
        })
    };
    handleCountryChange = (e) => {
        e.preventDefault();
        this.setState({
            country: e.target.value,
        })
    };
    handleCityChange = (e) => {
        e.preventDefault();
        this.setState({
            city: e.target.value,
        })
    };
    handleStateChange = (e) => {
        e.preventDefault();
        this.setState({
            state: e.target.value,
        })
    };
    handlePostalChange = (e) => {
        e.preventDefault();
        this.setState({
            postal: e.target.value,
        })
    };

    handleAdrBlur = (fieldName) => (e) => {
        this.setState({
            touched: {
                ...this.state.touched, [fieldName]: true
            },
        })
    };

    validateAdr(address, city, state, postal, country){
        return {
            address: address.length === 0,
            city: city.length === 0,
            state: state.length === 0,
            postal: postal.length === 0,
            country: country.length === 0,
        };
    };

    handleSubmitErr(e) {
        e.preventDefault();
        this.setState({
            touched: {
                address: true,
                city: true,
                postal: true,
                country: true,
                state: true,
            }
        })
    };


    uploadResellerCertificate = () => {
        this.refs.onUploadUserFile.click();
        this.__FILETYPE__ = 'certificate';
    };

    onUploadUserFile = async (evt) => {
        this.__FILE__ = evt.target.files;

        const formData = new FormData();
        // Save our new file name as `profile-ID.EXT`

        let epox = (new Date).getTime();

        if(this.state.cert_loc !== null) {
            const splitted = this.state.cert_loc.split('/');
            const uniC =  splitted[splitted.length-1].replace(/[^0-9]/g, '');
            //console.log('uniCert', uniC);
            epox = uniC;
        }

        //console.log('epox', epox);

        let fileName = `${this.__FILETYPE__}-${epox}.${this.__FILE__[0].name.split('.').pop()}`
        formData.append('file', this.__FILE__[0], fileName);
        let location = await request.post(`/api/user/upload/${this.__FILETYPE__}`)
            .send(formData)
            .then(resp => {
                //console.log(resp);
                return resp.body.Location;
            })
            .catch(err => {
                console.log(err);
                this.__FILE__ = null;
                this.__FILETYPE__ = null;
            });

        //console.log('done uploading');
        this.setState({uploadingCertificate: true});
        this.setState({cert_loc: location});
    };

    handleVerifyAddress = async(address, city, state, postal, country) => {
        //evt.preventDefault();
        let geoloc = await request.post(`/api/company/address/coordinates`)
            .send ({"address": {"address": address, "country": country, "city": city, "state": state, "postal": postal}
            })
            .then(resp => {
                //console.log('response',resp.body.geospatial);
                return resp.body;
            })
            .catch(err => {
                console.log(err);
            });

        //console.log('geoloc', geoloc);
        if (geoloc !== undefined) {
            this.setState({
                geo: geoloc.geospatial,
                lat: geoloc.latitude,
                long: geoloc.longitude,
                address_status: "valid",
            })
        }

    };

    render() {

        /*  let strV = '';
          if(this.state.flag === true) {
              strV = document.getElementById(`addressAutocomplete.street`).value
          }*/

        const errors = this.validateAdr(this.state.address, this.state.city, this.state.state, this.state.state, this.state.country);
        //console.log('errors', errors);

        const isDisabled = Object.keys(errors).some(x => errors[x]);
        //console.log('isDisabled', isDisabled);

        //console.log('touched', this.state.touched);

        const shouldShowError = (fieldName) => {
            const hasErr = errors[fieldName];
            const shouldShow = this.state.touched[fieldName];
            return hasErr ? shouldShow : false;
        };



        //console.log('street address state', this.state.address);
        //console.log('city state', this.state.city);
        //console.log('postal state', this.state.postal);
        //console.log('country state', this.state.country);
        //console.log('state state', this.state.state);

        const countryOpts = [
            {id: '', display: 'Select Country'},
            {id: 'US', display: 'USA'},
            {id: 'CA', display: 'Canada'},
        ];

        const caStateOpts = [
            {id: '', display: 'Select State'},
            { id: 'AL', display: 'Alberta'},
            { id: 'BC', display: 'British Columbia'},
            { id: 'MA', display: 'Manitoba'},
            { id: 'NB', display: 'New Brunswik'},
            { id: 'NL', display: 'Newfoundlend and Labrador'},
            { id: 'NS', display: 'Nova Scotia'},
            { id: 'ON', display: 'Ontario'},
            { id: 'PEI', display: 'Price Edward Island'},
            { id: 'QU', display: 'Quebeck'},
            { id: 'SA', display: 'Saskatchewan'},
        ];

        const usStateOpts = [
            {id: '', display: 'Select State'},
            { id: 'AL', display: 'Alabama'},
            { id: 'AK', display: 'Alaska'},
            { id: 'AZ', display: 'Arizona'},
            { id: 'AR', display: 'Arkansas'},
            { id: 'CA', display: 'California'},
            { id: 'CO', display: 'Colorado'},
            { id: 'CT', display: 'Connecticut'},
            { id: 'DC', display: 'District of Columbia'},
            { id: 'DE', display: 'Delaware'},
            { id: 'FL', display: 'Florida'},
            { id: 'GA', display: 'Georgia'},
            { id: 'HI', display: 'Hawaii'},
            { id: 'ID', display: 'Idaho'},
            { id: 'IA', display: 'Iowa'},
            { id: 'IL', display: 'Illinois'},
            { id: 'IN', display: 'Indiana'},
            { id: 'KS', display: 'Kansas'},
            { id: 'KY', display: 'Kentucky'},
            { id: 'LA', display: 'Louisiana'},
            { id: 'ME', display: 'Maine'},
            { id: 'MD', display: 'Maryland'},
            { id: 'MA', display: 'Massachusetts'},
            { id: 'MI', display: 'Michigan'},
            { id: 'MN', display: 'Minnesota'},
            { id: 'MS', display: 'Mississippi'},
            { id: 'MO', display: 'Missouri'},
            { id: 'MT', display: 'Montana'},
            { id: 'NE', display: 'Nebraska'},
            { id: 'NH', display: 'New Hampshire'},
            { id: 'NJ', display: 'New Jersey'},
            { id: 'NM', display: 'New Mexico'},
            { id: 'NV', display: 'Nevada'},
            { id: 'NY', display: 'New York'},
            { id: 'NC', display: 'North Carolina'},
            { id: 'ND', display: 'North Dakota'},
            { id: 'OH', display: 'Ohio'},
            { id: 'OK', display: 'Oklahoma'},
            { id: 'OR', display: 'Oregon'},
            { id: 'PA', display: 'Pennsylvania'},
            { id: 'RI', display: 'Rhode Island'},
            { id: 'SC', display: 'South Carolina'},
            { id: 'SD', display: 'South Dakota'},
            { id: 'TN', display: 'Tennessee'},
            { id: 'TX', display: 'Texas'},
            { id: 'UT', display: 'Utah'},
            { id: 'VT', display: 'Vermont'},
            { id: 'VA', display: 'Virginia'},
            { id: 'WA', display: 'Washington'},
            { id: 'WV', display: 'West Virginia'},
            { id: 'WI', display: 'Wisconsin'},
            { id: 'WY', display: 'Wyoming'}
        ];

        const segmentOps = [
            {id: "commerical", display: "Commerical"},
            {id: "home_automation", display: "Home Automation"},
            {id: "industrial", display: "Industrial"},
            {id: "residential", display: "Residential"},
        ];

        const servicesOpts = [
            {id: "audio_visual", display: "Audio/Visual"},
            {id: "high_voltage_install", display: "High Voltage Install"},
            {id: "low_voltage_install", display: "Low Voltage Install"},
            {id: "smart_home_install", display: "Smart Home Install"},
            {id: "wholehome_automation", display: "Wholehome Automation"},
        ];

        const refferalOpts = [
            {id: "customer", display: "Customer"},
            {id: "distributor", display: "Distributer"},
            {id: "email", display: "Email"},
            {id: "facebook", display: "Facebook"},
            {id: "instagram", display: "Instagram"},
            {id: "lighting_showroom", display: "Lighting Showroom"},
            {id: "print_ad", display: "Print Ad"},
            {id: "sales_rep", display: "Sales Rep"},
            {id: "tradeshow", display: "Tradeshow"},
            {id: "tv", display: "TV"},
            {id: "word_of_mouth", display: "Word of Mouth"},
        ];

        const businessOpts = [
            {id: "", display: "Business Type*"},
            {id: "av_solution_provider", display: "AV Solution Provider"},
            {id: "electrical_wholesale", display: "Electrical Wholesale"},
            {id: "lighting_showrooml", display: "Lighting Showroom"},
            {id: "lighting_wholesale", display: "Lighting Wholesale"},
        ];


        const ProfileSchema = Yup.object().shape({
            email: Yup.string().email('This value should be a valid email.').required('This value is required.'),
            first_name: Yup.string().required('This value is required.'),
            last_name: Yup.string().required('This value is required.'),
            name: Yup.string().required('This value is required.'),
            dba: Yup.string().required('This value is required.'),
            primary_jobtitle: Yup.string().required('This value is required.'),
            phone: Yup.string().required('This value is required.'),
            //country: Yup.string().required('This value is required.'),
            //address: Yup.string().required('This value is required.'),
            //city: Yup.string().required('This value is required.'),
            //state: Yup.string().required('This value is required.'),
            //postal: Yup.string().required('This value is required.').matches(/^[a-zA-Z0-9]*$/, 'This value should be alphanumeric characters only'),
            domain: Yup.string().required('This value is required.').url('This value should be a valid url.'),
            //years_in_business: Yup.string().required('This value is required.'),
            //coverage_segments: Yup.string().required('This value is required.'),
            //services_offered: Yup.string().required('This value is required.'),
            //number_of_employees: Yup.string().required('This value is required.'),
            business_type: Yup.string().required('This value is required'),
        });

        //console.log('error', this.state.isError);
        //console.log('success', this.state.isSubmited);

        if(this.state.isSubmited === true) {
            return <Redirect to='/signup/reseller' />
        }

        return(
            <div className='whiteBox--form'>
                <div className='whiteBox--form-header'>
                    <h2 className='signUp-home-title'>Become a NOON Pro Today</h2>
                    <h1>NOON Distributor</h1>
                    <p>As a NOON Distributor, you will have access to NOON at wholesale pricing, view training materials, sales and marketing assets, and news and frequently asked questions to keep you up to date.</p>
                    <hr className='form-divider'/>
                </div>

                <div className='white-f-form'>
                    <section>
                        <input ref="onUploadUserFile" onChange={this.onUploadUserFile} style={{display: 'none'}} type="file" />
                    </section>
                    <Formik
                        initialValues={{
                            email: "",
                            first_name: "",
                            last_name: "",
                            name: "",
                            dba: "",
                            primary_jobtitle: "",
                            phone: "",
                            domain:"",
                            reseller_certification: "",
                            years_in_business: "",
                            dealer_finder: true,
                            business_type:"",
                        }}
                        enableReinitialize={false}
                        validationSchema={ProfileSchema}
                        onSubmit={ async (values, actions) => {

                            /*let yearsInB = parseInt(values.years_in_business, 10);
                            let numberOfE = parseInt(values.number_of_employees, 10);

                            let hearedAbout = "";
                            if (values.additional_information_hearAboutNoon != "" && values.additional_information_hearAboutNoon != [] ) {
                                hearedAbout = values.additional_information_hearAboutNoon.join(",")
                            }
                            console.log('about N', hearedAbout);
                            let cSegments = "";
                            if (values.coverage_segments!= "" && values.coverage_segments != [] ) {
                                cSegments = values.coverage_segments.join(",")
                            }
                            // console.log('s segs', cSegments);

                            let servicesO = "";
                            if (values.services_offered!= "" && values.services_offered != [] ) {
                                servicesO = values.services_offered.join(",")
                            }
                            //console.log('services', servicesO);

                            let staffTraining = "";
                            if(values.provide_staff_training === false) {
                                staffTraining = "0";
                            }
                            if(values.provide_staff_training === true) {
                                staffTraining = "1";
                            }*/

                            if(this.state.address === "") {
                                actions.isSubmitting = false;
                            }

                            let data =  await this.handleVerifyAddress(this.state.address, this.state.city, this.state.state, this.state.postal, this.state.country,);


                            return new Promise((resolve, reject) =>{
                                request.post('/api/signup')
                                    .send({
                                        role: this.state.role,
                                        email: values.email,
                                        username: values.email,
                                        first_name: values.first_name,
                                        last_name: values.last_name,
                                        name: values.name,
                                        dba: values.dba,
                                        primary_jobtitle: values.primary_jobtitle,
                                        phone: values.phone,
                                        domain: values.domain,
                                        reseller_certification: values.reseller_certification,
                                        reseller_certification_path: this.state.cert_loc,
                                        dealer_finder: values.dealer_finder,
                                        business_type: values.business_type,
                                        address_status: this.state.address_status,
                                        latitude: this.state.lat,
                                        longitude: this.state.long,
                                        geospatial: this.state.geo,
                                        country: this.state.country,
                                        address: this.state.address,
                                        city: this.state.city,
                                        state: this.state.state,
                                        postal: this.state.postal,


                                        speciality: null,
                                        business_coverage: null,
                                        coverage_range: null,
                                        years_in_business: null,
                                        number_of_employees: null,
                                        number_of_stores: null,
                                        primary_distributor: null,
                                        secondary_distributor: null,
                                        document_uuid: null,
                                        electrician_certification: null,
                                        coverage_segments: null,
                                        services_offered: null,
                                        experience_with_noon: null,
                                        provide_staff_training: null,
                                    })
                                    .then(data => {
                                        //console.log('finished user call');
                                        //console.log(data);
                                        this.setState({
                                            isSubmited: true,
                                            geo: null,
                                            lat: null,
                                            long: null,
                                            address_status:'',
                                        });
                                    })
                                    .catch(err => {
                                        console.error(err);
                                        this.setState({isError: true});
                                    })
                            });
                        }} >
                        {({
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              isSubmitting,
                              setSubmitting,
                              setFieldValue,
                              handleReset,
                              dirty,
                              isValid,
                              isValidating,
                          }) => (
                            <form className='my-f-form' onSubmit={e => {
                                handleSubmit(e);
                                if(isDisabled === true) {
                                    this.handleSubmitErr(e)
                                }
                            }}>
                                <h3 className='profile-data-section'>Primary Contact Information</h3>
                                <label className='form-f-label'>Email*</label>
                                <Field
                                    name='email'
                                    className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                    component='input'
                                    type='text'
                                    placeholder='Email*'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.email} />
                                {errors.email && touched.email ?
                                    (<div className='f-field-errors'>{errors.email} </div>) : null
                                }

                                <div className='flex--fields--holder'>
                                    <div className='flex-field-container'>
                                        <label className='form-f-label'>First Name*</label>
                                        <div className='flex-with-error-holder'>
                                            <Field
                                                name='first_name'
                                                component='input'
                                                className= {errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='First Name*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.first_name}
                                            />
                                            {errors.first_name && touched.first_name ? (
                                                <div className='f-field-errors'>{errors.first_name}</div>) : null
                                            }
                                        </div>
                                    </div>

                                    <div className='flex-field-container last'>
                                        <label className='form-f-label'>Last Name*</label>
                                        <div className='flex-with-error-holder'>
                                            <Field
                                                name='last_name'
                                                component='input'
                                                className= {errors.last_name && touched.last_name ?'form-f-field flex-with-error': 'form-f-field'}
                                                type='text'
                                                placeholder='Last Name*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.last_name}
                                            />
                                            {errors.last_name && touched.last_name ?
                                                (<div className='f-field-errors'>{errors.last_name}</div>): null
                                            }
                                        </div>
                                    </div>
                                </div>

                                <h3 className='profile-data-section'>Business Information</h3>

                                <label className='form-f-label'>Company Name*</label>
                                <Field
                                    name='name'
                                    component='input'
                                    className={errors.name && touched.name ? 'form-f-field with-error' : 'form-f-field'}
                                    type='text'
                                    placeholder='Company Name*'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.name}
                                />
                                {errors.name && touched.name ?
                                    (<div className='f-field-errors'>{errors.name}</div>) : null
                                }

                                <label className='form-f-label'>Doing Business As (DBA)*</label>
                                <Field
                                    name='dba'
                                    component='input'
                                    className={errors.dba && touched.dba ? 'form-f-field with-error' : 'form-f-field'}
                                    type='text'
                                    placeholder='Doing Business As*'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.dba}
                                />
                                {errors.dba && touched.dba ?
                                    (<div className='f-field-errors'>{errors.dba}</div>) : null
                                }

                                <label className='form-f-label'>Job Title*</label>
                                <Field
                                    name='primary_jobtitle'
                                    component='input'
                                    className={errors.primary_jobtitle && touched.primary_jobtitle ? 'form-f-field with-error' : 'form-f-field'}
                                    type='text'
                                    placeholder='Job Title*'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.primary_jobtitle}
                                />
                                {errors.primary_jobtitle && touched.primary_jobtitle ?
                                    (<div className='f-field-errors'>{errors.primary_jobtitle}</div>): null
                                }

                                <label className='form-f-label'>Primary Phone*</label>
                                <Field
                                    name='phone'
                                    component='input'
                                    className={errors.phone && touched.phone ? 'form-f-field with-error' : 'form-f-field'}
                                    type='text'
                                    placeholder='(___)___-____'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.phone}
                                />
                                {errors.phone && touched.phone ?
                                    (<div className='f-field-errors'>{errors.phone}</div>) : null
                                }

                                <label className='form-f-label'>Country*</label>
                                <select
                                    id='addressAutocomplete.country'
                                    name='country'
                                    className='single-choice-selector'
                                    value={this.state.country}
                                    onChange={e => this.handleCountryChange(e)}
                                    onBlur={this.handleAdrBlur('country')}
                                >
                                    {countryOpts.map(option => (
                                        <option key={`country-${option.id}`} value={option.id}>
                                            {option.display}
                                        </option>
                                    ))}
                                </select>
                                {shouldShowError('country') ?
                                    (<div className='f-field-errors'>This value is required.</div>) : null
                                }

                                <label className='form-f-label'>Address*</label>
                                <input
                                    name='address'
                                    className={shouldShowError('address') ? 'form-f-field with-error' : 'form-f-field'}
                                    type='text'
                                    id='addressAutocomplete.street'
                                    placeholder='Address*'
                                    value={this.state.address}
                                    onChange={e => this.handleAdrChange(e)}
                                    onBlur={this.handleAdrBlur('address')}
                                />
                                {shouldShowError('address') ?
                                    (<div className='f-field-errors'>This value is required.</div>) : null
                                }

                                <div className='flex--fields--holder'>
                                    <div className='flex-field-container'>
                                        <label className='form-f-label'>City*</label>
                                        <input
                                            name='city'
                                            className={shouldShowError('city') ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            id='addressAutocomplete.city'
                                            placeholder='City*'
                                            value={this.state.city}
                                            onChange={e => this.handleCityChange(e)}
                                            onBlur={this.handleAdrBlur('city')}
                                        />
                                        {shouldShowError('city') ?
                                            (<div className='f-field-errors'>This value is required.</div>) : null
                                        }
                                    </div>

                                    {this.state.country === 'CA' ?
                                        <div className='flex-field-container'>
                                            <label className='flex-form-label'>State*</label>
                                            <select
                                                name='state'
                                                id='addressAutocomplete.state'
                                                className='state-selector'
                                                placeholder='State'
                                                value={this.state.state}
                                                onChange={e => this.handleStateChange(e)}
                                                onBlur={this.handleAdrBlur('state')}
                                            >
                                                {caStateOpts.map(option => (
                                                    <option key={`state-${option.id}`}
                                                            value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </select>
                                            {shouldShowError('state') ?
                                                (<div className='f-field-errors'>This value is required.</div>) : null
                                            }
                                        </div>:
                                        <div className='flex-field-container'>
                                            <label className='flex-form-label'>State*</label>
                                            <select
                                                name='state'
                                                id='addressAutocomplete.state'
                                                className='state-selector'
                                                placeholder='State'
                                                value={this.state.state}
                                                onChange={e => this.handleStateChange(e)}
                                                onBlur={this.handleAdrBlur('state')}
                                            >
                                                {usStateOpts.map(option => (
                                                    <option key={`state-${option.id}`}
                                                            value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </select>
                                            {shouldShowError('state') ?
                                                (<div className='f-field-errors'>This value is required.</div>) : null
                                            }
                                        </div>
                                    }

                                    <div className='flex-field-container last'>
                                        <label className='form-f-label'>Postal Code*</label>
                                        <input
                                            name='postal'
                                            id='addressAutocomplete.postal'
                                            className={shouldShowError('postal') ? 'form-f-field with-error' : 'form-f-field'}
                                            type='text'
                                            placeholder='Postal Code*'
                                            value={this.state.postal}
                                            onChange={e => this.handlePostalChange(e)}
                                            onBlur={this.handleAdrBlur('postal')}
                                        />
                                        {shouldShowError('postal') ?
                                            (<div className='f-field-errors'>This value is required.</div>) : null
                                        }
                                    </div>
                                </div>


                                <label className='form-f-label'>Website*</label>
                                <Field
                                    name='domain'
                                    component='input'
                                    className={errors.domain && touched.domain ? 'form-f-field with-error': 'form-f-field'}
                                    type='text'
                                    placeholder='Website*'
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.domain}
                                />
                                {errors.domain && touched.domain ?
                                    (<div className='f-field-errors'>{errors.domain}</div>): null
                                }

                                <label className='form-f-label'>Reseller Certification Number</label>
                                <input className='form-f-field'
                                       type='text'
                                       name='reseller_certification'
                                       placeholder='Reseller Certification Number'
                                       onChange={handleChange}
                                       onBlur={handleBlur}
                                       value={values.reseller_certification}
                                />

                                <p className='disclaimer--copy'>Specify your reseller tax number and state
                                    above and upload a copy of your reseller certificate below.
                                    If you sell in multiple states, please upload them as a zip file. If no
                                    reseller certificate is provided, applicable sales tax will be charged
                                    on your purchases.</p>
                                <br/>
                                <section>
                                    <a className='edit-p-button' onClick={this.uploadResellerCertificate}>{this.state.uploadingCertificate ? 'Certificate Uploaded' : 'Upload Certificate'}</a>
                                    <input name="onUploadUserFile" onChange={this.onUploadUserFile} style={{display: 'none'}} type="file" />
                                </section>
                                <br/>

                                <label className='form-f-label'>Business Type*</label>
                                <Field name='business_type' component='select'
                                       className='single-choice-selector'>
                                    {businessOpts.map(option => (
                                        <option key={`business_type-${option.id}`} value={option.id}>
                                            {option.display}
                                        </option>
                                    ))}
                                </Field>
                                {errors.business_type && touched.business_type ?
                                    (<div className='f-field-errors'>{errors.business_type}</div>): null
                                }


                                <div className='toggle-switch-gr'>
                                    <input
                                        type='checkbox'
                                        className='toggle--input--btn'
                                        name='dealer_finder'
                                        checked={values.dealer_finder}
                                        onChange={handleChange}
                                    />
                                    <p className='toggle-in-label'>Add to NOON Finder?</p>
                                </div>
                                <br/>

                                <div className='error-box-cont'>
                                    {this.state.isError === true ?
                                        <p className='submission-error-text'>Ooops something went wrong! Please try again later</p>:
                                        null
                                    }
                                </div>

                                {dirty === true && isValid === true && isDisabled === true ?
                                    <button type='submit' className='form-f-button' onClick={e => this.handleSubmitErr(e)}> Submit Application</button> :
                                    <button type='submit' className='form-f-button'> Submit Application</button>
                                }

                            </form>
                        )}
                    </Formik>
                </div>
            </div>
        );
    }
};


// WEBPACK FOOTER //
// ./src/routes/UserSignupHome/DistributorForm.js